import Vue from "vue";
import { LoginForm, LanguageForm, Tooltip, Dialog, Lightbox, Infopage } from "@/components/";

Object.defineProperty(Vue.prototype, "$loginForm", { value: LoginForm });
Object.defineProperty(Vue.prototype, "$languageForm", { value: LanguageForm });
Object.defineProperty(Vue.prototype, "$tooltip", { value: Tooltip });
Object.defineProperty(Vue.prototype, "$dialog", { value: Dialog });
Object.defineProperty(Vue.prototype, "$lightbox", { value: Lightbox });
Object.defineProperty(Vue.prototype, "$infopage", { value: Infopage });
